/* eslint-disable react-hooks/exhaustive-deps */
import  { useEffect, useState } from "react";
import DataOutlet from "../../components/Card/data-outlet";
import { FaAddressCard, FaSpinner } from "react-icons/fa";
import { BsDatabaseFillCheck } from "react-icons/bs";
import { MdRefresh } from "react-icons/md";
import { IoMdSearch } from "react-icons/io";
import { API_URL_AUTH, API_URL_PAY } from "../../config";
import JumSIM from "../../components/Card/jumlah-sim";
import api from "../../config/api";
import LoadingPage from "../Loading";

const Outlet = () => {
  const today = new Date();

  const formatDate = (date) => {
    const pad = (num) => num.toString().padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
      date.getDate()
    )}`;
  };

  const [dataOutlet, setDataOutlet] = useState([]);
  const [startDate, setStartDate] = useState(formatDate(today));
  const [endDate, setEndDate] = useState(formatDate(today));
  const [total1Sim, setTotal1Sim] = useState(0);
  const [total2Sim, setTotal2Sim] = useState(0);
  const [allTotal, setAllTotal] = useState(0);
  const [searchTrigger, setSearchTrigger] = useState(0);

  const [loading, setLoading] = useState({
    total1Sim: true,
    total2Sim: true,
    allTotal: true,
  });

  // const navigate = useNavigate();

  // === Function Ambil Data ===
  const _handleSearch = () => {
    getDataOutlet();
    setSearchTrigger((prev) => prev + 1);
  };

  const getDataOutlet = async () => {
    try {
      const response = await api.get(
        `${API_URL_AUTH}/mopsimapp/all-outlet-group`
      );
      setDataOutlet(response.data.data);
    } catch (error) {
      console.log(error.message);
    }
  };

  const getTotal1Sim = async () => {
    try {
      const response = await api.get(
        `${API_URL_PAY}/mopsimapp/alltotal-sim?jmlSim=1&periode=5&outletId=&date_first=${new Date(
          startDate
        ).getTime()}&date_second=${new Date(endDate).getTime()}`
      );
      setTotal1Sim(response.data.total);
    } catch (error) {
      console.log(error.message);
    }
  };

  const getTotal2Sim = async () => {
    try {
      const response = await api.get(
        `${API_URL_PAY}/mopsimapp/alltotal-sim?jmlSim=2&periode=5&outletId=&date_first=${new Date(
          startDate
        ).getTime()}&date_second=${new Date(endDate).getTime()}`
      );
      setTotal2Sim(response.data.total);
    } catch (error) {
      console.log(error.message);
    }
  };

  const getTotalAll = async () => {
    try {
      const response = await api.get(
        `${API_URL_PAY}/mopsimapp/alltotal-sim?outletId=&periode=5&date_first=${new Date(
          startDate
        ).getTime()}&date_second=${new Date(endDate).getTime()}`
      );
      setAllTotal(response.data.total);
    } catch (error) {
      console.log(error.message);
    }
  };

  // === useEffect Awal ===
  useEffect(() => {
    _handleSearch();

    setTimeout(
      () => setLoading((prev) => ({ ...prev, total1Sim: false })),
      1000
    );
    setTimeout(
      () => setLoading((prev) => ({ ...prev, total2Sim: false })),
      2000
    );
    setTimeout(
      () => setLoading((prev) => ({ ...prev, allTotal: false })),
      3000
    );
  }, []);

  const convertDate = (date) => {
    let dateConv = new Date(date);
    var milliseconds = dateConv.getTime();
    return milliseconds;
  };

  return (
    <>
      <div className="min-h-screen h-full p-4 bg-gradient-to-b from-gray-300 to-teal-800">
        <h1 className="font-bold text-xl md:text-2xl mb-4 text-amber-700">
          Detail Laporang Outlet
        </h1>
        <div className="flex flex-col md:flex-row w-full gap-2 field-body mb-4">
          <div className="w-full">
            <label htmlFor="start-date">Dari Tanggal</label>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="input is-small w-full border-1 border-secondary hover:border-secondary/90 rounded-lg bg-gray-200"
            />
          </div>
          <div className="w-full">
            <label htmlFor="end-date">Sampai Tanggal</label>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              min={startDate}
              className="input is-small w-full hover:border-secondary/90 rounded-lg bg-gray-200"
            />
          </div>
          <div className="grid grid-cols-2 gap-2 md:w-[500px]">
            <button
              onClick={() => window.location.reload()}
              className="btn md:mt-6 px-2 py-1 md:order-last rounded-lg flex justify-center items-center gap-2 bg-amber-700 text-white hover:scale-95"
            >
              <MdRefresh /> Refresh
            </button>
            <button
              onClick={() => {
                _handleSearch()
                getTotalAll()
                getTotal1Sim()
                getTotal2Sim()
              }}
               disabled={loading.allTotal && loading.total1Sim && loading.total2Sim}
              className="btn md:mt-6 px-2 py-1 rounded-lg flex justify-center items-center gap-2 bg-gradient-to-b from-gray-600 to-teal-800 text-white hover:scale-95"
            >
            {loading.allTotal && loading.total1Sim && loading.total2Sim ? (
                <>
                  <FaSpinner className="animate-spin" color="light" />
                  Loading
                </>
              ) : (
                  <>
                    <IoMdSearch /> Cari
                </>
              )}
            </button>
          </div>
        </div>
        {loading.allTotal && loading.total1Sim && loading.total2Sim ? (
          <LoadingPage message="Memuat data..." showSkeleton={false} />
        ) : allTotal === 0 ? (
            <div className="flex justify-center items-center h-[300px]">
            <div className="text-center">
              <div className="flex justify-center mb-4">
                <FaAddressCard size={100} color="gray" />
              </div>
              <h2 className="text-gray-600 font-semibold">
                Data outlet tidak ditemukan
              </h2>
              <p className="text-gray-500">
                Silakan klik tombol refresh atau cari kembali
              </p>
            </div>
            </div>
          ) : (
          <>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <DataOutlet
                total={total1Sim}
                name={"TOTAL 1 SIM"}
                icon={<FaAddressCard size={32} color="white" />}
                loading={loading.total1Sim}
              />
              <DataOutlet
                total={total2Sim}
                name={"TOTAL 2 SIM"}
                icon={<FaAddressCard size={32} color="white" />}
                loading={loading.total2Sim}
              />
              <DataOutlet
                total={allTotal}
                name={"TOTAL SEMUA"}
                icon={<BsDatabaseFillCheck size={32} color="white" />}
                loading={loading.allTotal}
              />
            </div>
            {dataOutlet &&
              dataOutlet.map((item, index) => (
                <div
                  key={index}
                  className="mt-4 border rounded-xl border-gray-300 h-fit shadow"
                >
                  <h1 className="font-bold text-xl p-2 text-center rounded-t-xl text-white bg-gradient-to-b from-gray-800 to-teal-800">
                    {item.title}
                  </h1>

                  {item.data &&
                    item.data.map((outItem, index) => {
                      const isLast = index === item.data.length - 1; // Periksa apakah elemen terakhir
                      return (
                        <div
                          key={outItem.id}
                          className={`grid grid-cols-7 p-2 shadow border-b border-gray-400 bg-gray-300 ${isLast ? "rounded-b-xl" : ""
                            }`}
                        >
                          <div className="col-span-4">
                            <h4 className="font-bold text-[10px] md:text-xl">
                              {outItem.namaOutlet}
                            </h4>
                            <h4 className="font-semibold text-[8px] md:text-[14px] text-amber-700">
                              {outItem.kesatuan}
                            </h4>
                          </div>
                          <JumSIM
                            id={outItem.id}
                            startDate={convertDate(startDate)}
                            endDate={convertDate(endDate)}
                            trigger={searchTrigger}
                          />
                        </div>
                      );
                    })}
                </div>
              ))}
          </>)}
      </div>
    </>
  );
};

export default Outlet;
